// Add series color to legend point
import Highcharts from 'highcharts'

(function(H) {
    H.wrap(H.Legend.prototype, 'getAllItems', function(proceed) {
        const allItems = proceed.apply(this, Array.prototype.slice.call(arguments, 1));

        return allItems.map(function(item) {
            item.chart.series.map(el => {
                if (el.userOptions.data[0] && typeof el.userOptions.data[0] === 'object' && 'color' in el.userOptions.data[0] && el.userOptions.data[0].color) {
                    el.color = el.userOptions.data[0].color
                }

                return el
            })
            return item
        });
    });
}(Highcharts));

export default Highcharts
